module.exports = __webpack_public_path__ + "img/vip_bg.4b82184e.jpg";